module.exports = __webpack_public_path__ + "static/img/bottom_img_magician.a0b1dc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news/bottom_img_magician.png
// module id = /8m/
// module chunks = 57